import React, { FC, useEffect, useState } from 'react';
import { Select } from 'antd';
import { SelectProps } from 'antd/es/select';

import { GameConfig } from '@services/_api';
import client from '@services/client';

export type ClientVersionSearchSelectProps = SelectProps<string> & {
  environment?: string;
};

const ClientVersionSearchSelect: FC<ClientVersionSearchSelectProps> = ({
  environment,
  ...selectProps
}) => {
  const [gameConfigs, setGameConfigs] = useState<GameConfig[]>([]);

  useEffect(() => {
    client.api.gameConfigControllerGetAll().then((res) => {
      if (res.ok) {
        setGameConfigs(res.data ?? []);
      }
    });
  }, []);

  const clientVersions = Array.from(
    new Map(
      gameConfigs
        .filter((item) => item.environment === environment)
        .map((item) => [item.clientVersion, item]),
    ).values(),
  );

  return (
    <Select<string>
      placeholder="Search client version"
      showSearch
      allowClear
      optionFilterProp="children"
      {...selectProps}
    >
      {clientVersions.map((item) => (
        <Select.Option key={item.clientVersion} value={item.clientVersion}>
          {item.clientVersion} (Blueprint {item.blueprintVersion})
        </Select.Option>
      ))}
    </Select>
  );
};

export default ClientVersionSearchSelect;
